// Sentry — error tracking + performance monitoring (init before React renders).
// Background: 2026-05-09 incident (frontend bundle env-var regression) showed
// we have no out-of-band visibility into bundle deploys. Sentry catches uncaught
// exceptions, route-level errors via ErrorBoundary, and ships alerts to
// info@aeo-orchestra.com.
//
// Graceful degradation: if REACT_APP_SENTRY_DSN is unset at BUILD time, init
// is skipped. Runtime env changes do nothing — the value is inlined into the
// bundle by Vite at build, see Dockerfile ARG REACT_APP_SENTRY_DSN.
import * as Sentry from "@sentry/react";

const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN;
const APP_VERSION = process.env.REACT_APP_VERSION || "dev";
const ENVIRONMENT = process.env.NODE_ENV || "production";

const SENSITIVE_KEYS = ["password", "api_key", "apikey", "token", "secret", "authorization", "cookie"];
function scrubMapping(mapping) {
  if (!mapping || typeof mapping !== "object") return;
  Object.keys(mapping).forEach((k) => {
    if (SENSITIVE_KEYS.some((s) => k.toLowerCase().includes(s))) {
      mapping[k] = "[SCRUBBED]";
    }
  });
}

if (SENTRY_DSN) {
  Sentry.init({
    dsn: SENTRY_DSN,
    environment: ENVIRONMENT,
    release: `aeo-orchestra-frontend@${APP_VERSION}`,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0.0,
    replaysOnErrorSampleRate: 1.0,
    sendDefaultPii: true,
    beforeSend(event) {
      try {
        if (event.request) {
          scrubMapping(event.request.data);
          scrubMapping(event.request.headers);
          scrubMapping(event.request.cookies);
        }
        scrubMapping(event.extra);
      } catch (_) {
        // never let scrubbing block an error event
      }
      return event;
    },
  });
  // eslint-disable-next-line no-console
  console.log(`[Sentry] Frontend initialized, env=${ENVIRONMENT}, release=aeo-orchestra-frontend@${APP_VERSION}`);
} else if (ENVIRONMENT === "production") {
  // eslint-disable-next-line no-console
  console.warn("[Sentry] REACT_APP_SENTRY_DSN unset in production build — error tracking DISABLED");
}
